(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3798],{

/***/ 93291:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _typeof = (__webpack_require__(58921)["default"]);

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 58921:
/***/ (function(module) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}

module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 636:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgArrowDownBlue(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.5,
    height: 6.323,
    viewBox: "0 0 10.5 6.323"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M5.271 3.848L8.631.587a.97.97 0 011.338 0 .9.9 0 010 1.308L5.945 5.801a.97.97 0 01-1.348 0L.525 1.895a.915.915 0 010-1.308.97.97 0 011.338 0z",
    fill: "#194dff",
    stroke: "#fff",
    strokeWidth: 0.5
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgArrowDownBlue);

/***/ }),

/***/ 2289:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgTelephone(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 510.003 510.003",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M68.787 239.517L34.394 273.91 0 308.304v201.213h255.002l10-195-10-195.001H255l-97.998-9.848z",
    fill: "#27e7f0"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M255.002 119.516v390.001H510V308.304l-34.392-34.394-34.395-34.393L360 119.516zM86.94 30.944c-12.17 5.239-23.153 11.053-32.892 17.399-11.157 7.271-20.68 15.244-28.482 23.858-8.203 9.058-14.451 18.731-18.718 28.952C2.393 111.828.1 123.1.001 134.891v22.312L0 179.516l75 10 75-10v-15c0-13.214 17.378-27.402 44.98-36.238 16.768-5.368 37.309-8.762 60.02-8.762h.002l10-59.513-10-59.513c-29.729.102-58.605 2.525-85.56 7.083-30.47 5.152-58.486 13.031-82.502 23.371z",
    fill: "#3ac0f1"
  })), _path3 || (_path3 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M360 164.516v15l75 10 75-10v-44.44c.179-23.511-8.14-44.799-24.46-63.234-13.471-15.217-32.394-28.49-56.489-39.466-23.479-10.693-51.366-18.904-81.996-24.315C320.334 3.34 291.527.751 261.739.503a631.277 631.277 0 00-3.368-.017c-1.124-.002-2.246 0-3.368.004v119.026c22.711.001 43.252 3.394 60.019 8.762C342.623 137.115 360 151.302 360 164.516z",
    fill: "#3a97f1"
  })), _path4 || (_path4 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M360 239.517h150V179.516H360v30z",
    fill: "#3a77f1"
  })), _path5 || (_path5 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M150 239.517H0v-60.001h150z",
    fill: "#3a97f1"
  })), _path6 || (_path6 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M350 344.517l8.925 15H390v-30H358.925z",
    fill: "#ccd2db"
  })), _path7 || (_path7 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M255 239.517c-28.948 0-55.198 11.775-74.211 30.788S150 315.568 150 344.517c0 28.948 11.776 55.198 30.789 74.211s45.263 30.789 74.211 30.789h.002l10-105-10-105h-.001z",
    fill: "#f3f5f9"
  })), _path8 || (_path8 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M360 344.517c0-28.949-11.775-55.199-30.787-74.212-19.013-19.013-45.263-30.788-74.211-30.788v210c28.948-.001 55.198-11.776 74.211-30.789C348.225 399.714 360 373.465 360 344.517z",
    fill: "#e1e6f0"
  })), _path9 || (_path9 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M255 299.517c-12.406 0-23.656 5.046-31.805 13.194C215.047 320.86 210 332.11 210 344.517c0 12.406 5.047 23.656 13.195 31.805 8.148 8.148 19.398 13.195 31.805 13.195h.002l10-45-10-45h-.001z",
    fill: "#e1e6f0"
  })), _path10 || (_path10 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M300 344.517c0-12.407-5.046-23.657-13.194-31.805-8.147-8.148-19.397-13.195-31.804-13.195v90c12.406-.001 23.656-5.048 31.804-13.196S300 356.923 300 344.517z",
    fill: "#ccd2db"
  })));
}

/* harmony default export */ __webpack_exports__["Z"] = (SvgTelephone);

/***/ }),

/***/ 87032:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(14859);

var _interopRequireWildcard = __webpack_require__(93291);

__webpack_unused_export__ = true;
exports.Z = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(58527));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(78834));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(38111));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(97111));

var _objectSpread5 = _interopRequireDefault(__webpack_require__(25782));

var _react = _interopRequireWildcard(__webpack_require__(2784));

var _propTypes = _interopRequireDefault(__webpack_require__(13980));

var _classnames = _interopRequireDefault(__webpack_require__(72779));

var _reactTransitionGroup = __webpack_require__(96090);

var _utils = __webpack_require__(13418);

var _transitionStatusToCl;

var propTypes = (0, _objectSpread5.default)({}, _reactTransitionGroup.Transition.propTypes, {
  isOpen: _propTypes.default.bool,
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
  tag: _utils.tagPropType,
  className: _propTypes.default.node,
  navbar: _propTypes.default.bool,
  cssModule: _propTypes.default.object,
  innerRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string, _propTypes.default.object])
});
var defaultProps = (0, _objectSpread5.default)({}, _reactTransitionGroup.Transition.defaultProps, {
  isOpen: false,
  appear: false,
  enter: true,
  exit: true,
  tag: 'div',
  timeout: _utils.TransitionTimeouts.Collapse
});
var transitionStatusToClassHash = (_transitionStatusToCl = {}, _transitionStatusToCl[_utils.TransitionStatuses.ENTERING] = 'collapsing', _transitionStatusToCl[_utils.TransitionStatuses.ENTERED] = 'collapse show', _transitionStatusToCl[_utils.TransitionStatuses.EXITING] = 'collapsing', _transitionStatusToCl[_utils.TransitionStatuses.EXITED] = 'collapse', _transitionStatusToCl);

function getTransitionClass(status) {
  return transitionStatusToClassHash[status] || 'collapse';
}

function getHeight(node) {
  return node.scrollHeight;
}

var Collapse =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(Collapse, _Component);

  function Collapse(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      height: null
    };
    ['onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited'].forEach(function (name) {
      _this[name] = _this[name].bind((0, _assertThisInitialized2.default)(_this));
    });
    return _this;
  }

  var _proto = Collapse.prototype;

  _proto.onEntering = function onEntering(node, isAppearing) {
    this.setState({
      height: getHeight(node)
    });
    this.props.onEntering(node, isAppearing);
  };

  _proto.onEntered = function onEntered(node, isAppearing) {
    this.setState({
      height: null
    });
    this.props.onEntered(node, isAppearing);
  };

  _proto.onExit = function onExit(node) {
    this.setState({
      height: getHeight(node)
    });
    this.props.onExit(node);
  };

  _proto.onExiting = function onExiting(node) {
    // getting this variable triggers a reflow
    var _unused = node.offsetHeight; // eslint-disable-line no-unused-vars

    this.setState({
      height: 0
    });
    this.props.onExiting(node);
  };

  _proto.onExited = function onExited(node) {
    this.setState({
      height: null
    });
    this.props.onExited(node);
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        Tag = _this$props.tag,
        isOpen = _this$props.isOpen,
        className = _this$props.className,
        navbar = _this$props.navbar,
        cssModule = _this$props.cssModule,
        children = _this$props.children,
        innerRef = _this$props.innerRef,
        otherProps = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["tag", "isOpen", "className", "navbar", "cssModule", "children", "innerRef"]);
    var height = this.state.height;
    var transitionProps = (0, _utils.pick)(otherProps, _utils.TransitionPropTypeKeys);
    var childProps = (0, _utils.omit)(otherProps, _utils.TransitionPropTypeKeys);
    return _react.default.createElement(_reactTransitionGroup.Transition, (0, _extends2.default)({}, transitionProps, {
      in: isOpen,
      onEntering: this.onEntering,
      onEntered: this.onEntered,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }), function (status) {
      var collapseClass = getTransitionClass(status);
      var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, collapseClass, navbar && 'navbar-collapse'), cssModule);
      var style = height === null ? null : {
        height: height
      };
      return _react.default.createElement(Tag, (0, _extends2.default)({}, childProps, {
        style: (0, _objectSpread5.default)({}, childProps.style, {}, style),
        className: classes,
        ref: _this2.props.innerRef
      }), children);
    });
  };

  return Collapse;
}(_react.Component);

Collapse.propTypes = propTypes;
Collapse.defaultProps = defaultProps;
var _default = Collapse;
exports.Z = _default;

/***/ }),

/***/ 20212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ FaqQuestions; }
});

// EXTERNAL MODULE: ../core/dist/_virtual/_tslib.js
var _tslib = __webpack_require__(30116);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/reactstrap/lib/Collapse.js
var Collapse = __webpack_require__(87032);
// EXTERNAL MODULE: ../core/dist/app-context.js
var app_context = __webpack_require__(4628);
// EXTERNAL MODULE: ../core/dist/node_modules/style-inject/dist/style-inject.es.js
var style_inject_es = __webpack_require__(36474);
;// CONCATENATED MODULE: ../core/dist/components/FaqQuestions/FaqQuestions.module.scss.js


var css_248z = ".FaqQuestions-module_question_layout__CTFyj {\n  background-color: #f6f6f6;\n}\n.FaqQuestions-module_question_layout__CTFyj .FaqQuestions-module_question__wWCMX {\n  display: flex;\n  justify-content: space-between;\n  cursor: pointer;\n}\n.FaqQuestions-module_question_layout__CTFyj .FaqQuestions-module_question__wWCMX h3 {\n  font-family: var(--font-semiBold);\n  color: #000000;\n  padding-right: 20px;\n}\n.FaqQuestions-module_question_layout__CTFyj .FaqQuestions-module_question__wWCMX h3 span {\n  display: inline-block;\n  border-right: solid 1px #e2e2e2;\n}\n.FaqQuestions-module_question_layout__CTFyj .FaqQuestions-module_question__wWCMX .FaqQuestions-module_collapse_icon__VTN-A {\n  margin-top: auto;\n  margin-bottom: auto;\n}\n.FaqQuestions-module_question_layout__CTFyj .FaqQuestions-module_question__wWCMX .FaqQuestions-module_collapse_icon__VTN-A .FaqQuestions-module_collapse_icon_minus__XPlPl path {\n  fill: #195af7;\n  opacity: 1;\n}\n.FaqQuestions-module_question_layout__CTFyj .FaqQuestions-module_answer__aR2v0 {\n  opacity: 0.6;\n}\n.FaqQuestions-module_question_layout__CTFyj .FaqQuestions-module_answer__aR2v0 p {\n  font-family: var(--font-medium);\n  color: #666666;\n  margin: 0;\n}\n.FaqQuestions-module_question_layout__CTFyj .FaqQuestions-module_answer__aR2v0 ul {\n  margin-bottom: 0;\n  margin-top: 10px;\n}\n.FaqQuestions-module_question_layout__CTFyj .FaqQuestions-module_answer__aR2v0 ul li {\n  font-family: var(--font-medium);\n  color: #666666;\n}\n.FaqQuestions-module_question_layout__CTFyj .FaqQuestions-module_arrowDown__7j3bD {\n  transform: rotate(-90deg);\n  display: block;\n}\n.FaqQuestions-module_question_layout__CTFyj .FaqQuestions-module_arrowTop__YpN3O {\n  transform: rotate(90deg);\n  display: block;\n}\n.FaqQuestions-module_question_layout__CTFyj .FaqQuestions-module_ques__CWrYR {\n  display: flex;\n  align-items: center;\n}\n\n@media (max-width: 991px) {\n  .FaqQuestions-module_question_layout__CTFyj {\n    padding: 15px 15px 15px 15px;\n    border-radius: 4px;\n    margin-bottom: 10px;\n  }\n  .FaqQuestions-module_question_layout__CTFyj .FaqQuestions-module_question__wWCMX h3 {\n    font-size: 0.75rem;\n    margin-bottom: 0;\n    line-height: 1.25rem;\n  }\n  .FaqQuestions-module_question_layout__CTFyj .FaqQuestions-module_question__wWCMX h3 span {\n    padding: 6px 15px 6px 0;\n    margin-right: 15px;\n  }\n  .FaqQuestions-module_question_layout__CTFyj .FaqQuestions-module_answer__aR2v0 p {\n    font-size: 0.75rem;\n    padding-top: 10px;\n  }\n  .FaqQuestions-module_question_layout__CTFyj .FaqQuestions-module_answer__aR2v0 ul li {\n    font-size: 0.75rem;\n  }\n  .FaqQuestions-module_question_layout__CTFyj .FaqQuestions-module_arrowDown__7j3bD svg {\n    width: 10px;\n  }\n  .FaqQuestions-module_question_layout__CTFyj .FaqQuestions-module_arrowTop__YpN3O svg {\n    width: 10px;\n  }\n}\n@media (min-width: 992px) {\n  .FaqQuestions-module_question_layout__CTFyj {\n    padding: 25px 40px 25px 25px;\n    border-radius: 8px;\n    margin-bottom: 15px;\n  }\n  .FaqQuestions-module_question_layout__CTFyj .FaqQuestions-module_question__wWCMX h3 {\n    font-size: 0.875rem;\n    margin-bottom: 0;\n    line-height: 1.375rem;\n  }\n  .FaqQuestions-module_question_layout__CTFyj .FaqQuestions-module_question__wWCMX h3 span {\n    padding: 6px 25px 6px 0;\n    margin-right: 15px;\n  }\n  .FaqQuestions-module_question_layout__CTFyj .FaqQuestions-module_answer__aR2v0 {\n    opacity: 0.6;\n    padding-left: 51px;\n  }\n  .FaqQuestions-module_question_layout__CTFyj .FaqQuestions-module_answer__aR2v0 p {\n    font-size: 0.875rem;\n    padding-top: 15px;\n  }\n  .FaqQuestions-module_question_layout__CTFyj .FaqQuestions-module_answer__aR2v0 ul li {\n    font-size: 0.875rem;\n  }\n}";
var faqQuestionStyle = {"question_layout":"FaqQuestions-module_question_layout__CTFyj","question":"FaqQuestions-module_question__wWCMX","collapse_icon":"FaqQuestions-module_collapse_icon__VTN-A","collapse_icon_minus":"FaqQuestions-module_collapse_icon_minus__XPlPl","answer":"FaqQuestions-module_answer__aR2v0","arrowDown":"FaqQuestions-module_arrowDown__7j3bD","arrowTop":"FaqQuestions-module_arrowTop__YpN3O","ques":"FaqQuestions-module_ques__CWrYR"};
(0,style_inject_es/* default */.Z)(css_248z);


//# sourceMappingURL=FaqQuestions.module.scss.js.map

// EXTERNAL MODULE: ../core/dist/icons/AngleRightGray.svg.js
var AngleRightGray_svg = __webpack_require__(85843);
// EXTERNAL MODULE: ../core/dist/constants/misc.js
var misc = __webpack_require__(77370);
// EXTERNAL MODULE: ../core/dist/components/skeleton/Skeleton.js + 1 modules
var Skeleton = __webpack_require__(71155);
// EXTERNAL MODULE: ../core/dist/components/app-anchor/A.js
var A = __webpack_require__(70561);
;// CONCATENATED MODULE: ../core/dist/components/FaqQuestions/FaqQuestions.js











const FaqQuestions = (_a) => {
    var _b;
    var { state = misc/* ComponentState.NORMAL */.hm.NORMAL } = _a, props = (0,_tslib/* __rest */._)(_a, ["state"]);
    const { data, index, handleClick, isOpen } = props;
    const { isMobile } = (0,react.useContext)(app_context/* AppContext */.Il);
    if (state === misc/* ComponentState.NORMAL */.hm.NORMAL) {
        return (react.createElement("div", { className: classnames_default()(faqQuestionStyle.question_layout) },
            react.createElement("div", { className: classnames_default()(faqQuestionStyle.question, faqQuestionStyle.collapsible), onClick: () => handleClick({ currentFaqIndex: index, isOpen: !isOpen }), key: index },
                react.createElement("h3", { className: classnames_default()(faqQuestionStyle.ques) },
                    !isMobile ? react.createElement("span", null, index + 1) : "",
                    " ",
                    data.question),
                react.createElement("div", { className: classnames_default()(faqQuestionStyle.collapse_icon) }, !isOpen ? (react.createElement("span", { className: faqQuestionStyle.arrowDown },
                    react.createElement(AngleRightGray_svg/* ReactComponent */.r, null))) : (react.createElement("span", { className: faqQuestionStyle.arrowTop },
                    react.createElement(AngleRightGray_svg/* ReactComponent */.r, { className: classnames_default()(faqQuestionStyle.collapse_icon_minus) }))))),
            react.createElement(Collapse/* default */.Z, { isOpen: isOpen },
                react.createElement("div", { className: classnames_default()(faqQuestionStyle.answer) },
                    data.response ? (react.createElement("p", null,
                        data.response,
                        data.link && react.createElement(A/* default */.Z, { href: data.link }, " here."))) : (""),
                    data.subContent ? (react.createElement("ul", null, (_b = data.subContent) === null || _b === void 0 ? void 0 : _b.map((content, index) => (react.createElement("li", { key: index },
                        " ",
                        react.createElement("div", { dangerouslySetInnerHTML: { __html: content } })))))) : ("")))));
    }
    else {
        return (react.createElement("div", { className: classnames_default()(faqQuestionStyle.question_layout) },
            react.createElement("div", { className: classnames_default()(faqQuestionStyle.question, faqQuestionStyle.collapsible) },
                react.createElement("h3", { className: classnames_default()(faqQuestionStyle.ques) },
                    react.createElement(Skeleton["default"], null)),
                react.createElement(Skeleton["default"], null))));
    }
};


//# sourceMappingURL=FaqQuestions.js.map


/***/ }),

/***/ 46168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ QuickFilterPill; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../core/dist/node_modules/style-inject/dist/style-inject.es.js
var style_inject_es = __webpack_require__(36474);
;// CONCATENATED MODULE: ../core/dist/components/quick-filter-pill/QuickFilterPill.module.scss.js


var css_248z = ".QuickFilterPill-module_container__f0pwH {\n  display: flex;\n  align-items: center;\n  border: 2px solid #e9e9e9;\n  background-color: #ffffff;\n  white-space: nowrap;\n  color: #202124;\n  cursor: pointer;\n}\n.QuickFilterPill-module_container__f0pwH.QuickFilterPill-module_selected__fzeZK {\n  background-color: #f0f4fc;\n  font-family: var(--font-medium);\n  border-color: #1053ff;\n}\n.QuickFilterPill-module_container__f0pwH.QuickFilterPill-module_selected__fzeZK .QuickFilterPill-module_text__co2Ao {\n  color: #1053ff;\n}\n.QuickFilterPill-module_container__f0pwH.QuickFilterPill-module_loading__iK-d9 {\n  padding: 0 !important;\n  border: 2px solid transparent !important;\n}\n.QuickFilterPill-module_container__f0pwH .QuickFilterPill-module_prefix__67LJS,\n.QuickFilterPill-module_container__f0pwH .QuickFilterPill-module_suffix__yDauR {\n  display: flex;\n}\n.QuickFilterPill-module_container__f0pwH.QuickFilterPill-module_mobile__lK8eO {\n  border-radius: 15px;\n  font-size: 0.75rem;\n  letter-spacing: -0.0075rem;\n  height: 30px;\n  padding: 8px 16px;\n}\n.QuickFilterPill-module_container__f0pwH.QuickFilterPill-module_mobile__lK8eO .QuickFilterPill-module_prefix__67LJS {\n  padding-right: 6px;\n}\n.QuickFilterPill-module_container__f0pwH.QuickFilterPill-module_mobile__lK8eO .QuickFilterPill-module_suffix__yDauR {\n  padding-left: 6px;\n}\n.QuickFilterPill-module_container__f0pwH.QuickFilterPill-module_desktop__kbGi0 {\n  border-radius: 20.5px;\n  font-size: 0.8125rem;\n  letter-spacing: -0.00875rem;\n  height: 38px;\n  padding: 3px 10px 0px 10px;\n}\n.QuickFilterPill-module_container__f0pwH.QuickFilterPill-module_desktop__kbGi0 .QuickFilterPill-module_prefix__67LJS {\n  padding-right: 8px;\n}\n.QuickFilterPill-module_container__f0pwH.QuickFilterPill-module_desktop__kbGi0 .QuickFilterPill-module_suffix__yDauR {\n  padding-left: 8px;\n}";
var QuickFilterPillStyles = {"container":"QuickFilterPill-module_container__f0pwH","selected":"QuickFilterPill-module_selected__fzeZK","text":"QuickFilterPill-module_text__co2Ao","loading":"QuickFilterPill-module_loading__iK-d9","prefix":"QuickFilterPill-module_prefix__67LJS","suffix":"QuickFilterPill-module_suffix__yDauR","mobile":"QuickFilterPill-module_mobile__lK8eO","desktop":"QuickFilterPill-module_desktop__kbGi0"};
(0,style_inject_es/* default */.Z)(css_248z);


//# sourceMappingURL=QuickFilterPill.module.scss.js.map

// EXTERNAL MODULE: ../core/dist/components/skeleton/Skeleton.js + 1 modules
var Skeleton = __webpack_require__(71155);
;// CONCATENATED MODULE: ../core/dist/components/quick-filter-pill/QuickFilterPill.js





function QuickFilterPill({ text, prefix, suffix, isMobile, className, selectedClassName, prefixClassName, suffixClassName, isSelected = false, onSelected, onDeselected, data, isLoading }) {
    const _onSelected = () => {
        onSelected === null || onSelected === void 0 ? void 0 : onSelected(data);
    };
    const _onDeselected = () => {
        onDeselected === null || onDeselected === void 0 ? void 0 : onDeselected(data);
    };
    return (react.createElement("div", { className: classnames_default()(QuickFilterPillStyles.container, isSelected && QuickFilterPillStyles.selected, isSelected && selectedClassName, isMobile ? QuickFilterPillStyles.mobile : QuickFilterPillStyles.desktop, isLoading && QuickFilterPillStyles.loading, className), onClick: isSelected ? _onDeselected : _onSelected }, !isLoading ? (react.createElement(react.Fragment, null,
        " ",
        prefix && (react.createElement("span", { className: classnames_default()(QuickFilterPillStyles.prefix, prefixClassName) }, prefix)),
        text && react.createElement("span", { className: "quickFilterPill__text" }, text),
        suffix && (react.createElement("span", { className: classnames_default()(QuickFilterPillStyles.suffix, suffixClassName) }, suffix)))) : (react.createElement(Skeleton["default"], { width: "100px", type: "pill" }))));
}


//# sourceMappingURL=QuickFilterPill.js.map


/***/ }),

/***/ 53679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ResponsiveContainer; }
});

// EXTERNAL MODULE: ../core/dist/_virtual/_tslib.js
var _tslib = __webpack_require__(30116);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../core/dist/node_modules/style-inject/dist/style-inject.es.js
var style_inject_es = __webpack_require__(36474);
;// CONCATENATED MODULE: ../core/dist/components/responsive-container/ResponsiveContainer.module.scss.js


var css_248z = ".ResponsiveContainer-module_container_box__vbXde {\n  display: flex;\n  flex-wrap: wrap;\n}";
var Styles = {"container_box":"ResponsiveContainer-module_container_box__vbXde"};
(0,style_inject_es/* default */.Z)(css_248z);


//# sourceMappingURL=ResponsiveContainer.module.scss.js.map

;// CONCATENATED MODULE: ../core/dist/components/responsive-container/ResponsiveContainer.js





const ResponsiveContainer = (_a) => {
    var { className, id } = _a, props = (0,_tslib/* __rest */._)(_a, ["className", "id"]);
    return (react.createElement("div", { id: id, className: classnames_default()(Styles.container_box, className) }, props.children));
};


//# sourceMappingURL=ResponsiveContainer.js.map


/***/ }),

/***/ 85843:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ SvgAngleRightGray; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgAngleRightGray(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.554,
    height: 13.125,
    viewBox: "0 0 7.554 13.125"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M.316 5.839L5.874.291a.983.983 0 111.394 1.385l-4.861 4.91 4.861 4.861a.983.983 0 11-1.394 1.385L.316 7.282a.982.982 0 010-1.444z",
    fill: "#80868b"
  })));
}


//# sourceMappingURL=AngleRightGray.svg.js.map


/***/ }),

/***/ 96696:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _seo_header_PageSeo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83347);
/* harmony import */ var _methods_pageSeo__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61706);
/* harmony import */ var _vahak_core_dist_constants_platformStats__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28230);






var getCityMetaDescription = function(cityName) {
    return "Book ".concat(_vahak_core_dist_constants_platformStats__WEBPACK_IMPORTED_MODULE_5__/* .PLATFORM_STATS.liveLoadsAndLorries.label */ .s.liveLoadsAndLorries.label, " loads and lorries in ").concat(cityName, "! Vahak is the #1 platform for ").concat(cityName, " transport services. Join India's largest transporter network today for free.");
};
/**
 * Registers page SEO with the global SeoProvider.
 * Rendering is handled by GlobalSeoHead in _app — route defaults live in methods/pageSeo.ts.
 */ var PageMetaTags = function(param) {
    var cityName = param.cityName, titleProp = param.title, descriptionProp = param.description, _keywords = param.keywords, keywords = _keywords === void 0 ? "" : _keywords, asPath = param.asPath, locale = param.locale, localeNeutralPath = param.localeNeutralPath, hreflangLocales = param.hreflangLocales, canonicalUrlProp = param.canonicalUrl, ogUrl = param.ogUrl, ogDescription = param.ogDescription, _ogImgSrc = param.ogImgSrc, ogImgSrc = _ogImgSrc === void 0 ? (0,_methods_pageSeo__WEBPACK_IMPORTED_MODULE_4__/* .getDefaultOgImage */ .av)() : _ogImgSrc, ogImgAltTextProp = param.ogImgAltText, ogType = param.ogType, ogSiteName = param.ogSiteName, schema = param.schema, schemaOrgJsonUrlProp = param.schemaOrgJsonUrl, _includeDefaultSchema = param.includeDefaultSchema, includeDefaultSchema = _includeDefaultSchema === void 0 ? false : _includeDefaultSchema, _shouldBeIndexed = param.shouldBeIndexed, shouldBeIndexed = _shouldBeIndexed === void 0 ? true : _shouldBeIndexed, breadcrumbList = param.breadcrumbList, _schemaType = param.schemaType, schemaType = _schemaType === void 0 ? "WebPage" : _schemaType, faqList = param.faqList, children = param.children;
    var title = titleProp !== null && titleProp !== void 0 ? titleProp : cityName ? "Vahak - Book Best Transport Services in ".concat(cityName) : undefined;
    var description = descriptionProp !== null && descriptionProp !== void 0 ? descriptionProp : cityName ? getCityMetaDescription(cityName) : undefined;
    var canonicalUrl = canonicalUrlProp !== null && canonicalUrlProp !== void 0 ? canonicalUrlProp : cityName ? "https://www.vahak.in/city/".concat(cityName) : undefined;
    var schemaOrgJsonUrl = schemaOrgJsonUrlProp !== null && schemaOrgJsonUrlProp !== void 0 ? schemaOrgJsonUrlProp : cityName ? "/city/".concat(cityName) : undefined;
    var ogImgAltText = ogImgAltTextProp !== null && ogImgAltTextProp !== void 0 ? ogImgAltTextProp : description;
    var seoConfig = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return {
            title: title,
            description: description,
            keywords: keywords,
            asPath: asPath,
            locale: locale,
            localeNeutralPath: localeNeutralPath,
            hreflangLocales: hreflangLocales,
            canonicalUrl: asPath ? undefined : canonicalUrl,
            ogUrl: ogUrl,
            ogDescription: ogDescription,
            ogImgSrc: ogImgSrc,
            ogImgAltText: ogImgAltText,
            ogType: ogType,
            ogSiteName: ogSiteName,
            schema: schema,
            schemaOrgJsonUrl: schemaOrgJsonUrl,
            includeDefaultSchema: includeDefaultSchema,
            shouldBeIndexed: shouldBeIndexed,
            breadcrumbList: breadcrumbList,
            schemaType: schemaType,
            faqList: faqList
        };
    }, [
        title,
        description,
        keywords,
        asPath,
        locale,
        localeNeutralPath,
        hreflangLocales,
        canonicalUrl,
        ogUrl,
        ogDescription,
        ogImgSrc,
        ogImgAltText,
        ogType,
        ogSiteName,
        schema,
        schemaOrgJsonUrl,
        includeDefaultSchema,
        shouldBeIndexed,
        breadcrumbList,
        schemaType,
        faqList
    ]);
    (0,_seo_header_PageSeo__WEBPACK_IMPORTED_MODULE_3__/* .useRegisterPageSeo */ .C9)(seoConfig);
    if (!children) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PageMetaTags);


/***/ }),

/***/ 53798:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ faq_Faq; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 7 modules
var esm = __webpack_require__(42386);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../core/dist/app-context.js
var app_context = __webpack_require__(4628);
// EXTERNAL MODULE: ./components/faq/Faq.module.scss
var Faq_module = __webpack_require__(25822);
var Faq_module_default = /*#__PURE__*/__webpack_require__.n(Faq_module);
// EXTERNAL MODULE: ./components/faq/FaqHeader/FaqHeader.module.scss
var FaqHeader_module = __webpack_require__(20202);
var FaqHeader_module_default = /*#__PURE__*/__webpack_require__.n(FaqHeader_module);
// EXTERNAL MODULE: ../core/dist/components/quick-filter-pill/QuickFilterPill.js + 1 modules
var QuickFilterPill = __webpack_require__(46168);
// EXTERNAL MODULE: ../core/dist/components/responsive-container/ResponsiveContainer.js + 1 modules
var ResponsiveContainer = __webpack_require__(53679);
// EXTERNAL MODULE: ../core/dist/icons/ArrowDownBlue.svg
var ArrowDownBlue = __webpack_require__(636);
// EXTERNAL MODULE: ../core/dist/constants/Faq.js
var Faq = __webpack_require__(80230);
// EXTERNAL MODULE: ../core/dist/components/app-btn/AppBtn.js + 2 modules
var AppBtn = __webpack_require__(49995);
;// CONCATENATED MODULE: ./components/faq/FaqHeader/FaqHeader.tsx








// Component


// Icon



var FaqHeader = function(param) {
    var heading = param.heading, subHeading = param.subHeading, handleCategorySelect = param.handleCategorySelect, selectedFaqCateg = param.selectedFaqCateg;
    var isMobile = (0,react.useContext)(app_context/* AppContext */.Il).isMobile;
    var onSelectFaqCateg = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(item) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        handleCategorySelect({
                            categ: item
                        });
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onSelectFaqCateg(item) {
            return _ref.apply(this, arguments);
        };
    }();
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: classnames_default()((FaqHeader_module_default()).section),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((FaqHeader_module_default()).header_layout, "container"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: classnames_default()((FaqHeader_module_default()).heading),
                                children: heading
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: classnames_default()((FaqHeader_module_default()).subHeading),
                                children: subHeading
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()((FaqHeader_module_default()).category_card, "".concat(isMobile ? (FaqHeader_module_default()).mobile : "")),
                        children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (FaqHeader_module_default()).faqDropDownBox,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("select", {
                                    onChange: function(e) {
                                        var ref;
                                        e.persist();
                                        onSelectFaqCateg(Faq/* FaqCategories.find */.og.find(function(c) {
                                            return c.slug === e.target.value;
                                        }) || selectedFaqCateg);
                                        router.push("/frequently-asked-questions/[params]", "/frequently-asked-questions/".concat(e.target.value === ((ref = Faq/* FaqCategories.0 */.og[0]) === null || ref === void 0 ? void 0 : ref.slug) ? "" : e.target.value));
                                    },
                                    children: Faq/* FaqCategories.map */.og.map(function(category) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                            value: category.slug,
                                            selected: selectedFaqCateg.slug === category.slug,
                                            children: category.name
                                        }, category.slug);
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: (FaqHeader_module_default()).iconDownArrow,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowDownBlue/* default */.Z, {})
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveContainer/* default */.Z, {
                            className: classnames_default()((FaqHeader_module_default()).category_pills_container),
                            children: Faq/* FaqCategories */.og === null || Faq/* FaqCategories */.og === void 0 ? void 0 : Faq/* FaqCategories.map */.og.map(function(param) {
                                var name = param.name, slug = param.slug;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(AppBtn/* default */.Z, {
                                    type: "link",
                                    className: (FaqHeader_module_default()).categoryButtonContainer,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(QuickFilterPill/* default */.Z, {
                                        className: (FaqHeader_module_default()).categoryButton,
                                        text: name,
                                        data: {
                                            name: name,
                                            slug: slug
                                        },
                                        isSelected: selectedFaqCateg.slug === slug,
                                        selectedClassName: (FaqHeader_module_default()).selectedCategory,
                                        onSelected: onSelectFaqCateg
                                    })
                                }, slug);
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var FaqHeader_FaqHeader = (FaqHeader);

// EXTERNAL MODULE: ../core/dist/components/app-anchor/A.js
var A = __webpack_require__(70561);
// EXTERNAL MODULE: ../core/dist/components/FaqQuestions/FaqQuestions.js + 1 modules
var FaqQuestions = __webpack_require__(20212);
// EXTERNAL MODULE: ./components/common/page-meta-tags/PageMetaTags.tsx
var PageMetaTags = __webpack_require__(96696);
// EXTERNAL MODULE: ../core/dist/_services/faq.service.js
var faq_service = __webpack_require__(99891);
// EXTERNAL MODULE: ../core/dist/icons/telephone.svg
var telephone = __webpack_require__(2289);
// EXTERNAL MODULE: ../core/dist/constants/languages.js
var languages = __webpack_require__(87013);
;// CONCATENATED MODULE: ./components/faq/Faq.tsx








// Style

// Component




// Services

// Icons

// Constants


var GeneralCategory = {
    name: "General FAQ’s",
    slug: "general"
};
var Faq_Faq = function(param) {
    var slug = param.slug, locale = param.locale;
    var ref, ref1;
    var ref2 = (0,esm/* useTranslation */.$G)([
        "faq"
    ]), t = ref2.t, i18n = ref2.i18n;
    var router = (0,next_router.useRouter)();
    var ref3 = (0,react.useState)(undefined), activeFaq = ref3[0], setActiveFaq = ref3[1];
    var ref4 = (0,react.useState)(true), isOpen = ref4[0], setIsOpen = ref4[1];
    var ref5 = (0,react.useState)(0), faqCount = ref5[0], setFaqCount = ref5[1];
    var ref6 = (0,react.useState)(5), showMoreCount = ref6[0], setShowMoreCount = ref6[1];
    var ref7 = (0,react.useState)(GeneralCategory), selectedFaqCateg = ref7[0], setSelectedFaqCateg = ref7[1];
    var isMobile = (0,react.useContext)(app_context/* AppContext */.Il).isMobile;
    (0,react.useEffect)(function() {
        var ref, ref1;
        var urlSlug = router.asPath.split("/").length === 3 ? router.asPath.split("/")[2] : slug;
        var urlCategory = Faq/* FaqCategories.filter */.og.filter(function(category) {
            return category.slug === urlSlug;
        });
        urlSlug && setSelectedFaqCateg(urlCategory[0] || GeneralCategory);
        var language = (ref = languages/* NAV_MENU_STRINGS.find */.ft.find(function(ele) {
            return ele.menu.includes("frequently-asked-questions");
        })) === null || ref === void 0 ? void 0 : (ref1 = ref.languages) === null || ref1 === void 0 ? void 0 : ref1.find(function(language) {
            return language.value === locale;
        });
        (language === null || language === void 0 ? void 0 : language.value) && i18n.changeLanguage(language === null || language === void 0 ? void 0 : language.value);
        (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var count;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return faq_service/* FaqService.getFaqsByCateg */.P.getFaqsByCateg({
                            categSlug: urlSlug || selectedFaqCateg.slug
                        });
                    case 2:
                        count = _ctx.sent.count;
                        setFaqCount(count);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    }, []);
    var getAndSetData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var categ;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        categ = param.categ;
                        router.push("/frequently-asked-questions/".concat(categ.slug));
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getAndSetData(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var toggleActiveFaq = function(val) {
        var currentFaqIndex = val.currentFaqIndex, isOpen = val.isOpen;
        setActiveFaq(activeFaq === currentFaqIndex ? undefined : currentFaqIndex);
        setIsOpen(!isOpen);
    };
    var faqPath = selectedFaqCateg.slug === "general" ? "/frequently-asked-questions" : "/frequently-asked-questions/".concat(selectedFaqCateg.slug);
    var canonicalUrl = "https://www.vahak.in".concat(faqPath);
    var categoryName = (ref = Faq/* FaqCategories.find */.og.find(function(categ) {
        return selectedFaqCateg.slug === categ.slug;
    })) === null || ref === void 0 ? void 0 : ref.name;
    var pageTitle = selectedFaqCateg.slug === "general" ? "Vahak - Frequently Asked Questions" : "Vahak - ".concat(categoryName, " FAQ");
    var _question, _response;
    var faqList = (0,react.useMemo)(function() {
        return (0,Faq/* useFaqQuestions */.z6)(t).filter(function(faqQuestion) {
            return faqQuestion.category === selectedFaqCateg.slug;
        }).flatMap(function(data) {
            return data.faqQuestions;
        }).slice(0, showMoreCount).map(function(item) {
            return {
                question: (_question = item.question) !== null && _question !== void 0 ? _question : "",
                answer: ((_response = item.response) !== null && _response !== void 0 ? _response : "").replace(/<[^>]*>/g, "")
            };
        });
    }, [
        t,
        selectedFaqCateg.slug,
        showMoreCount
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMetaTags/* default */.Z, {
                title: pageTitle,
                description: "Get answers to all your questions regarding booking loads, finding truck load online, lorry booking and more. Go through our FAQ and answers.",
                keywords: "lorry booking,how to get loads for trucks,find truck loads online,book my truck,online truck load booking, vahak, vahak app",
                canonicalUrl: canonicalUrl,
                ogUrl: canonicalUrl,
                ogImgAltText: "Book Trucks, Containers from Thousands of Trusted Transport businesses and Lorry Owners from All India",
                schemaOrgJsonUrl: faqPath,
                includeDefaultSchema: false,
                faqList: faqList
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FaqHeader_FaqHeader, {
                        heading: t("faq:faq_heading"),
                        subHeading: t("faq:faq_subheading"),
                        handleCategorySelect: getAndSetData,
                        selectedFaqCateg: selectedFaqCateg
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()((Faq_module_default()).main_layout, "".concat(isMobile ? (Faq_module_default()).mobile : (Faq_module_default()).desktop)),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    children: (ref1 = Faq/* FaqCategories.find */.og.find(function(categ) {
                                        return selectedFaqCateg.slug === categ.slug;
                                    })) === null || ref1 === void 0 ? void 0 : ref1.name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: (0,Faq/* useFaqQuestions */.z6)(t).filter(function(faqQuestion) {
                                        return faqQuestion.category === selectedFaqCateg.slug;
                                    }).map(function(data) {
                                        return data.faqQuestions.slice(0, showMoreCount).map(function(faqQuestion, index) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FaqQuestions/* default */.Z, {
                                                data: faqQuestion,
                                                index: index,
                                                handleClick: function(val) {
                                                    return toggleActiveFaq(val);
                                                },
                                                isOpen: activeFaq === index ? !isOpen : false
                                            }, index);
                                        });
                                    })
                                }),
                                showMoreCount >= 5 && faqCount > 5 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()((Faq_module_default()).show_more),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("u", {
                                            className: classnames_default()((Faq_module_default()).link),
                                            onClick: function() {
                                                return showMoreCount > 5 ? setShowMoreCount(5) : setShowMoreCount(faqCount);
                                            },
                                            children: showMoreCount > 5 ? t("faq:show_less") : t("faq:show_more")
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()((Faq_module_default()).contact_us),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: classnames_default()((Faq_module_default()).contact_us_wrapper),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classnames_default()((Faq_module_default()).contact_us_icon),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(telephone/* default */.Z, {
                                                    width: "50",
                                                    height: "50"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classnames_default()((Faq_module_default()).contact_us_content),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                                    children: [
                                                        t("faq:if_you_cant_findthe_answer"),
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(A/* default */.Z, {
                                                            openInNewTab: false,
                                                            href: "/contact-us",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("u", {
                                                                children: t("faq:contact_us")
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var faq_Faq = (Faq_Faq);


/***/ }),

/***/ 25822:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Faq_container__2hhyw","main_layout":"Faq_main_layout__yxUVE","desktop":"Faq_desktop__C7hHY","show_more":"Faq_show_more__ipXmM","contact_us":"Faq_contact_us__fx0G_","contact_us_wrapper":"Faq_contact_us_wrapper__MlU7m","contact_us_icon":"Faq_contact_us_icon__Webqp","contact_us_content":"Faq_contact_us_content__DHz2I"};

/***/ }),

/***/ 20202:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"FaqHeader_container__8foqt","section":"FaqHeader_section__I1_ak","header_layout":"FaqHeader_header_layout__d_GFt","heading":"FaqHeader_heading__0yZvJ","subHeading":"FaqHeader_subHeading__FmlHl","category_card":"FaqHeader_category_card__WA5yo","faqDropDownBox":"FaqHeader_faqDropDownBox__8TgfU","iconDownArrow":"FaqHeader_iconDownArrow__Os_Tc","category_pills_container":"FaqHeader_category_pills_container__dNAQA","categoryButtonContainer":"FaqHeader_categoryButtonContainer__LTnYs","categoryButton":"FaqHeader_categoryButton__6DhlK","selectedCategory":"FaqHeader_selectedCategory__p_5dY","category_pill":"FaqHeader_category_pill__d2zbq"};

/***/ })

}]);